import { useEffect, useState } from "react";

const KEY = "kc-theme";
const EVENT = "kc-theme-change";

export function useTheme() {
  const [theme, setThemeState] = useState(() => localStorage.getItem(KEY));
  useEffect(() => {
    const on = (e) => setThemeState(e.detail);
    window.addEventListener(EVENT, on);
    return () => window.removeEventListener(EVENT, on);
  }, []);
  const setTheme = (v) => {
    localStorage.setItem(KEY, v);
    window.dispatchEvent(new CustomEvent(EVENT, { detail: v }));
  };
  return [theme, setTheme];
}
